<div class="centered" >
  <div >
    <div class="daPic">
      <div style="text-align: center">
        <div class="titleFont" *ngIf="phoneApp" style="font-family: almoni; font-weight: bold; padding-top: 30%; color:white;font-size: 30px; padding-left: 0">Vessel Receiving </div>
      </div>
    </div>
  </div>
    <table class="mainTable" >
  <tr>
    <td class="mainUpperTd">

      <mat-card class="quickView" >
        <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
          <tr>
            <td style="width: 18%" >
              <div class="maher" (click)="myApp.showCharts()"></div>
            </td>

          </tr>
        </table>

        <div class="flex-item2" >
          <mat-table #table23 [dataSource]="quickViewData" multiTemplateDataRows matSort="container" >
            <ng-container matColumnDef="vessel_description" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader dateOut" >{{ dateOut | date: 'fullDate' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="justify-content: left">
                <table>
                  <tr>
                    <td>
                      {{row.vessel_description}}

                    </td>
                  </tr>
                  <tr>
                    <td class="recMessage">
                      {{row.text_message}}
                    </td>
                  </tr>
                </table>

              </mat-cell>
              <mat-footer-cell *matFooterCellDef="let row" class="matFooter" style="text-align: center">NOTE: No other vessel receiving will be allowed</mat-footer-cell>
            </ng-container>
            <ng-container matColumnDef="auto_on_off" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader"></mat-header-cell>
              <mat-cell *matCellDef="let row" style="justify-content: left">
                <table>
                  <tr>
                    <td class="autoDryHaz">
                        Auto:
                    </td>
                    <td style="font-family: almoni; font-size: 16px; text-transform: uppercase; padding-left: 5px; padding-right: 5px" [className]="row.auto_on_off == 'YES'? 'greenColor' : 'redColor'">
                      {{row.auto_on_off}}
                    </td>
                  </tr>
                  <tr>
                    <td class="autoDryHaz">
                      Dry:
                    </td>
                    <td style="font-family: almoni; font-size: 16px; text-transform: uppercase; padding-left: 5px; padding-right: 5px" [className]="row.dry_on_off == 'YES'? 'greenColor' : 'redColor'">
                      {{row.dry_on_off}}
                    </td>
                  </tr>
                  <tr>
                    <td class="autoDryHaz">
                       Haz:
                    </td>
                    <td style="font-family: almoni; font-size: 16px; text-transform: uppercase; padding-left: 5px; padding-right: 5px" [className]="row.hazards_on_off == 'YES'? 'greenColor' : 'redColor'">
                      {{row.hazards_on_off}}
                    </td>
                  </tr>

                </table>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef="let row"></mat-footer-cell>

            </ng-container>
            <mat-header-row *matHeaderRowDef="qvColumns; sticky: true"></mat-header-row>
            <mat-row   *matRowDef="let row; columns: qvColumns;" class="table-row" ></mat-row>
            <mat-footer-row *matFooterRowDef="qvColumns"></mat-footer-row>
          </mat-table>
          <mat-toolbar style="width: 100%; display: unset">
            <mat-toolbar-row style="width: 100%; ">
              <mat-paginator class="myPaginator"   [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
            </mat-toolbar-row>
          </mat-toolbar>
        </div>
      </mat-card>




    </td>
  </tr>
</table>
</div>
